/**
 * Language: English.
 */
export default {
    messages: {
        choose_thematic: "Choose Thematic",
        sessionReset: "Session will automatically reset in",
        minute: "minute",
        resetMap: "Reset Map",
        selectLanguage: "Select a Language",
        seconds: "seconds",
        cta: {
            "switch_standard_view": "Switch to standard view"
        },
        minutes: "minutes",
        multilevelwarning: "This is a multi-level path and goes via the Quick Link on Level 1",
        allexhibits: "All exhibitors",
        favorites: "Your exhibitors to visit",
        select_thematic: "Select Thematics",
        allexhibits_mobile: "All exhibitors",
        favorites_mobile: "Your exhibitors to visit",
        select_thematic_mobile: "Theme path",
        add_favorites: "Add to your exhibitors",
        remove_favorites: "Remove",
        add_favorites_toast: "Added to your list of exhibitors to visit",
        remove_favorites_toast: "Removed from your list of exhibitors to visit",
        api_error: "You need to login to access your exhibitors",
        level: "Level",
        destination: "Destination",
        origin: "Origin",
        sponsored_logo_selection: "Click on the brand logo to view the stand location",
        to_visit: "Visited",
        visited_toast: "The exhibitor has been marked as visited.",
        unvisited_toast: "Exhibitor no longer marked as visited"
    },
    thematics: {
        "umbrella": "Umbrellas and Pergolas",
        "smartoffice": "Smart Office",
        "eclectic": "Eclectic Design",
        "dol": "Domestic Outdoor lighting",
        "uol": "Urban Outdoor lighting",
        "homent": "Home Entertainment",
        "wallpaper": "Wallpaper",
        "rug": "Rugs",
    },
    thematicDescription: {
        "outdoor": "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces.",
        "textile": "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship.",
        "wallpaper": "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics.",
        "kitchen": "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces.",
        "bathroom": "Highly innovative interiors: water sustainability according to Salotto NY.",
        "umbrella": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Dolor sit amet consectetur adipiscing elit quisque faucibus.",
        "smartoffice": "Adipiscing elit quisque faucibus ex sapien vitae pellentesque.",
        "eclectic": "Vitae pellentesque sem placerat in id cursus mi. Cursus mi pretium tellus duis convallis tempus leo.",
        "dol": "Tempus leo eu aenean sed diam urna tempor. Urna tempor pulvinar vivamus fringilla lacus nec metus.",
        "uol": " Semper vel class aptent taciti sociosqu ad litora. Conubia nostra inceptos himenaeos orci varius natoque penatibus.",
        "homent": "Dis parturient montes nascetur ridiculus mus donec rhoncus.",
        "rug": "Nulla molestie mattis scelerisque maximus eget fermentum odio. Purus est efficitur laoreet mauris pharetra vestibulum fusce."
    },
    errors: {
        loadingLibrary: "Failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
    keyboard: {
        space: "Space",
    },
    indoor: {
        'Search': 'Search',
        'Itinerary': 'Itinerary',
        'Monday': 'Monday',
        'Tuesday': 'Tuesday',
        'Wednesday': 'Wednesday',
        'Thursday': 'Thursday',
        'Friday': 'Friday',
        'Saturday': 'Saturday',
        'Sunday': 'Sunday',
        'levels': 'levels',
        'level': 'level',
        'Level': 'Level',
        'Select Positions': 'Select Positions',
        'Type a origin': 'Type a origin',
        'Type a destination': 'Type a destination',
        'No route found': 'No route found',
        'Shops': 'Shops',
        'at Level': 'at Level',
        'At': 'At',
        'up': 'up',
        'down': 'down',
        'Your Location': 'Your Location',
        'Accessible for people with disabilities': 'Accessible for people with disabilities',
        'Navigate': 'Navigate',
        'Then': 'Then',
        'you are arrived': 'you are arrived',
        'Overview': 'Overview',
        'Center': 'Center',
        'Less than 1min': "Less than 1 min",
        'Next': "Next",
        'Previous': "Previous",
        'Quit': "Quit",
        'Resume': "Resume",
        'in': "in",
        'Open': "Open",
        'Closed': "Closed",
        'Closes at': "Closes at",
        'Opens': "Opens",
        'tomorrow': "tomorrow",
        'at': 'at',
        'Select a location and a destination': "Select a location and a destination",
        'Disability compliant': "Disability compliant",
        'ETA': "ETA",
        'search_stop': "Search brand to add stop...",
        "stop_cta": "Intermediate stops",
        "stop_search_label": "Add Stops",
        "steps": "stops",
        "optimized_route_cta_label": "Create optimized Route",
        "optimized_route_cta_desc": "Optimize your route to visit your favorite exhibitors.",
        "optimized_route_cta_button": "Create your route",
        "route_loader_header": "Calculating optimal route",
        "route_loader_title": "Finding the best path for your visit",
        "route_panel_title": "Create Route",
        "route_field_origin_label": "Starting Point",
        "route_field_des_label": "Final Destination",
        "exit_gate_label": "Indicate your fair exit gate",
        "cancel": "Cancel",
        "from": "from",
        "to": "to",
        "results_summary_header": "Optimized Route",
        "edit": "Edit",
        "start_navigation": "Start Navigation",
        "exit_gate_warning": "By selecting the fair exit gate, the route’s final destination will be overwritten",
        "duplicate_stop_warning": "Stop already exists in route",
        "for": "for",
        "go_to_stop": "Bring me to stop",
        "of": "of",
        "meters": "meters",
        "Pause": "Pause",
        "Steps": "Stops",
        "leg_step": "Steps",
        "final_destination": "Final destination",
        "max_stop_limit_warning": "Max stop limit exceeded",
        "set_as_origin": "Set as origin",
        "set_as_destination": "Set as destination",
        "same_origin_destination_warning": "Origin and destination can’t be the same",
        "fav_route_builder_heading": "Your list of exhibitors to visit",
        "fav_route_builder_sub_heading": "Select up to 15 and set starting point / final destination to create your personalized route",
        "fav_route_builder_selected_exhibitors": "Selected exhibitors:",
        "fav_route_builder_min_stop_message": "Select at least 3 exhibitors you wish to visit to create your personalised route.",
        'destination_in_sight': 'Destination in sight!',
        'continue_to_reach': 'Continue for {distance} to reach {name}',
        'unauthorised_favs': 'Log in and select the exhibitors you wish to visit to create your personalised route.',
        'unauthorized_map_toast': 'Log in to create your list of exhibitors to visit',
        'empty_map_toast': 'Search for an exhibitor or tap their name on the map to add them to your personal list',
        "edit_stops": "Edit stops",
        "route_builder_toast": "Set the origin and destination to optimize the route."
    }
};
